import React, { useState } from 'react';

const ValueOfWhatCalculator = () => {
  const [value1, setValue1] = useState('');
  const [value2, setValue2] = useState('');
  const [result, setResult] = useState('');
  const [explanation, setExplanation] = useState('');
  const [error, setError] = useState('');

  const handleCalculate = () => {
    if (!value1 || !value2) {
      setError('يرجى ادخال القيمتين بشكل صحيح');
      setResult('');
      setExplanation('');
      return;
    }
    const percentageOfWhat = (parseFloat(value1) / parseFloat(value2)) * 100;
    setResult(percentageOfWhat.toFixed(2));
    setExplanation(
      `${value1} هو ${percentageOfWhat.toFixed(2)}% من ماذا ${value2} = (${value1} / ${value2}) * 100 = ${(parseFloat(value1) / parseFloat(value2)) * 100
      } = ${percentageOfWhat.toFixed(4)}`
    );
    setError('');
  };

  return (
    <div dir="rtl">
      <style>{`
        .calc-wrapper {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 6px;
        }
        .calc-btn {
          font-size: 20px;
          white-space: nowrap;
        }
        @media (max-width: 767px) {
          .calc-btn {
            width: 100%;
            margin-top: 6px;
            text-align: center;
          }
        }
      `}</style>

      <div className="calc-wrapper">
        <input
          type="number"
          placeholder="القيمة"
          value={value1}
          onChange={(e) => setValue1(e.target.value)}
          className="form-control"
          style={{ flex: 1, minWidth: '70px' }}
        />
        <span>هو</span>
        <input
          type="number"
          placeholder="النسبة"
          value={value2}
          onChange={(e) => setValue2(e.target.value)}
          className="form-control"
          style={{ flex: 1, minWidth: '70px' }}
        />
        <span>% من ماذا</span>
        <button
          className="btn btn-success"
          onClick={handleCalculate}
        >
          إحسب
        </button>
      </div>

      <br />
      <div>
        {error !== '' ? (
          <p className="p-3 mb-2 bg-warning text-white">خطأ: {error}</p>
        ) : (
          <>
            {result !== '' && (
              <>
                <p className="p-3 mb-2 bg-success text-white">
                  النتيجة: {value1} هو {value2}% من {result}
                </p>
                {explanation !== '' && (
                  <p className="p-3 mb-2 bg-info text-black">
                    خطوات الحل: <br />{explanation}
                  </p>
                )}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default ValueOfWhatCalculator;